module.exports = __webpack_public_path__ + "images/back-to-top.3e7ee23c.svg";